import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import MainCta from '../botones/main-cta'
import Multicanalidad from '../botones/multi-chuzo-week'
import DesktopHero from '../../../static/images/chuzo-week/hero-image-desktop.jpg'
import MobileHero from '../../../static/images/chuzo-week/hero-image-mobile.jpg'

const Container = styled.div`
  background-image:url(${MobileHero});
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  background-size: cover;
  text-align: center;
  margin: 0 auto;

  ${breakpoint('tablet')`
  background-image:url(${DesktopHero}) !important;
`}

  h1 {
    font-size: 2em;
    color: white;
    margin: 0 0 0.3em;
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    color: ${props => props.theme.colors.grisOscuro};
    margin: 0 0 0.5em;
  }

  p {
    color: white;
    margin-bottom: 0 0 1.5em;
    font-size: 20px !important;
    width: 100%;
    font-weight: 400;

    ${breakpoint('tablet')`
    width: 80%;
    `}
  }

  ${breakpoint('desktop')`
    h1{
      font-size: 3em;
    }

    h2{
      font-size: 2em;
    }

    a {
      font-size: 1.3em;
    }
  `}

  video {
    max-width: 100%;
  }
`

const DivText = styled.div`
    margin-top:280px;

    ${breakpoint('tablet')`
      margin-top:0px;
    `}
`

const Wrapper = styled.div`
  padding: 3em 2em;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    display: flex;
    text-align: left;
    justify-content: center;

    & > div {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 50%;
      max-width: 500px;
      box-sizing: border-box;
    }

    & > div:first-of-type {
      padding-right: 20px;
    }
  `}
`

const H1 = styled.h1 `
    margin-top: -17px !important;
    font-weight: 800;
    color: white !important;
    font-size: 3.5em !important;
`


const Header = ({ formUrl, multicanalidad, pais }) => (
  <Container>
    <Wrapper>
      <DivText>
        <H1>¡Llegó</H1>
        <H1>Chuzo Week!</H1>
        <p>Aprovechá del 2 al 8 de diciembre las condiciones especiales y horario extendido (de 6 a.m a 12 m.n) para comprar tu carro en línea.</p>
        {multicanalidad == null ? (
          <MainCta to={formUrl}>
            Llen{["CRI", "NIC"].includes(pais.contryAbr) ? "á" : "a"} el
            formulario
          </MainCta>
        ) : (
          <Multicanalidad multicanalidad={multicanalidad} />
        )}
      </DivText>
      <div>
          <div>

          </div>
      </div>
    </Wrapper>
  </Container>
);

export default Header